<script>
import axios from "axios";
import moment from "moment";
import { TicketsPath } from "@/path";
import Swal from "sweetalert2";

export default {
  props: ["category"],
  components: {},
  data() {
    return {
      selected_value: null,
      all_weeks: [{ value: null, text: "Select Week" }],
      text: "",
      response: null,
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      description: "",
      form: {
        category: this.category,
        extra_details: {
          selected_week: null,
        },
      },
      showSelectedWeekAlert: false,
      showDescriptionAlert: false,
    };
  },
  mounted() {
    const currentWeek = moment().isoWeek();
    const currentYear = moment().format("YYYY");
    const previousYear = (parseInt(currentYear) - 1).toString();

    for (let i = 1; i < currentWeek; i++) {
      let d = this.getWeekStartAndEnd(i, currentYear);
      this.all_weeks.push({
        value: { month: i, year: currentYear },
        text: "Week - " + i + " - " + d.startOfWeek + " ~ " + d.endOfWeek,
      });
    }

    const totalWeeksPreviousYear = this.getNumberOfWeeks(previousYear);

    for (let i = totalWeeksPreviousYear; i >= 1; i--) {
      let d = this.getWeekStartAndEnd(i, previousYear);
      this.all_weeks.push({
        value: { month: i, year: previousYear },
        text: "Week - " + i + " - " + d.startOfWeek + " ~ " + d.endOfWeek,
      });
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit("setForm", this.form);
      },
    },
    selected_value() {
      this.selected_week = this.selected_value.month;
      this.selected_year = this.selected_value.year;
    },
    selected_week() {
      this.showSelectedWeekAlert = false;
    },
    description() {
      this.showDescriptionAlert = false;
    },
  },
  methods: {
    getNumberOfWeeks(year) {
      // Get the last day of the year
      let lastDayOfYear = moment().year(year).endOf("year");

      return lastDayOfYear.weeksInYear();
    },
    getWeekStartAndEnd(weekNumber, year) {
      // Set the year and week number
      let startOfWeek = moment()
        .year(year)
        .week(weekNumber)
        .startOf("week")
        .add(1, "days");
      let endOfWeek = moment()
        .year(year)
        .week(weekNumber)
        .endOf("week")
        .add(1, "days");

      return {
        startOfWeek: startOfWeek.format("YYYY-MM-DD"),
        endOfWeek: endOfWeek.format("YYYY-MM-DD"),
      };
    },
    async downloadWeekPayout() {
      let file =
        process.env.VUE_APP_AWS_CDN +
        "/payout-sheets/" +
        this.selected_week +
        "--" +
        this.selected_year +
        "/" +
        this.$store.state.authfack.user.restaurant.name +
        ".xlsx";
      window.open(file, "_blank");
    },
    async checkFileExists(url) {
      try {
        this.response = await fetch(url, {
          method: "GET",
          "Access-Control-Allow-Origin": "*",
        });
      } catch (error) {
        return false;
      }
    },
    async saveTicket() {
      if (!this.selected_week) {
        this.showSelectedWeekAlert = true;
        return;
      } else if (!this.description) {
        this.showDescriptionAlert = true;
        return;
      }
      try {
        let res = await axios.post(this.baseUrl + TicketsPath.SAVE_TICKET, {
          category: "payout",
          extra_details: {
            selected_week: this.selected_week,
            Description: this.description,
          },
        });
        if (res.data.status) {
          Swal.fire("Success", "", "success").then(() => {
            this.$router.push("/tickets_dashboard");
          });
        } else {
          throw new Error("Failed to save");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<template>
  <div>
    <b-row style="color: black; font-size: 16px">
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-form-group label="Week:">
          <b-form-select
            v-model="selected_value"
            :options="all_weeks"
            value-field="value"
            text-field="text"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="margin-bottom: 10px" v-if="selected_week">
        <b-button variant="primary">
          <a @click="downloadWeekPayout" style="color: white"
            >Download Payout of week {{ selected_week }}</a
          >
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="selected_week">
      <b-col cols="12">
        <b-form-textarea
          id="textarea"
          v-model="description"
          placeholder="Type the issue with the payout"
          rows="6"
          max-rows="6"
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row v-if="!selected_week">
      <b-col sm="8" md="6" lg="6" xl="4">
        <div
          style="
            background-color: rgb(240, 240, 240);
            border-radius: 10px;
            padding: 10px;
            font-size: 16px;
          "
        >
          Note:- Select the week and write the issue that you are facing with
          the weeks payout
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showSelectedWeekAlert" variant="danger" dismissible>
          Please select a Week and enter your Issue with the Payout and Raise
          Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showDescriptionAlert" variant="danger" dismissible>
          Please enter the Issue with the Payout and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 100px" class="text-right text-sm-left">
      <b-col>
        <b-button variant="primary" class="mt-2" @click="saveTicket"
          >Raise Ticket</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<style></style>
